import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Pagination, PaginationParams} from '../model/pagination';
import {LocationDto, VoucherDto, VoucherTemplate} from '../model/continent';
import {cleaningParams} from '../functions/cleaningParams';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  constructor(private httpClient: HttpClient) {}

  private voucher: BehaviorSubject<VoucherDto> = new BehaviorSubject<VoucherDto>(new VoucherDto());
  private currentIndex: number = 0;
  vouchers: VoucherDto[] = [];


  getVouchersList(params: PaginationParams): Observable<Pagination<VoucherDto>> {
    const cleanParams = cleaningParams(params);
    return this.httpClient.get<Pagination<VoucherDto>>(`${environment.apiUrl}/voucher`,
      { params: { ...cleanParams } });
  }

  getVoucherStream(id: number, templateId: number): any {
    return this.httpClient.get(`${environment.apiUrl}/voucher/stream/${id}`, { responseType: 'blob', params: { 'templateId': templateId } });
  }

  getVoucherTemplate(params: PaginationParams): Observable<Pagination<VoucherTemplate>> {
    const cleanParams = cleaningParams(params);
    return this.httpClient.get<Pagination<VoucherTemplate>>(`${environment.apiUrl}/voucher-template`,
      { params: { ...cleanParams } });
  }

  getVoucherTemplates(): Observable<VoucherTemplate[]> {
    return this.httpClient.get<VoucherTemplate[]>(`${environment.apiUrl}/voucher/templates`);
  }

  getVoucherTemplateById(id: number): Observable<VoucherTemplate> {
    return this.httpClient.get<VoucherTemplate>(`${environment.apiUrl}/voucher-template/${id}`);
  }

  getVoucher(id: number): Observable<VoucherDto> {
    return this.httpClient.get<VoucherDto>(`${environment.apiUrl}/voucher/${id}`);
  }

  saveVoucher(Voucher: VoucherDto): Observable<VoucherDto> {
    return this.httpClient.post<VoucherDto>(`${environment.apiUrl}/voucher`, Voucher);
  }

  saveVoucherTemplate(voucherTemplate: VoucherTemplate): Observable<VoucherTemplate> {
    return this.httpClient.post<VoucherTemplate>(`${environment.apiUrl}/voucher-template`, voucherTemplate);
  }

  saveVoucherTemplateFile(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post(`${environment.apiUrl}/voucher-template/file/${id}`, formData);
  }

  delete(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/voucher/${id}`);
  }

  deleteVoucherTemplateFile(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/voucher-template/file/${id}`);
  }

  deleteVoucherTemplate(id: number): Observable<any> {
    return this.httpClient.delete(`${environment.apiUrl}/voucher-template/${id}`);
  }

}
